import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useIsPlatformAdmin } from '@/entities/user';
import { AppRoutes } from '@/shared/constants/app-routes.constant';

const RoleElementComponent = ({ children }: PropsWithChildren) => {
	const isPlatformAdmin = useIsPlatformAdmin();

	if (isPlatformAdmin) {
		return <>{children}</>;
	}

	return <Navigate to={AppRoutes.Home} />;
};

export default RoleElementComponent;
